// extracted by mini-css-extract-plugin
export var askAiIcon = "_ml-9";
export var container = "_ml-0";
export var groupSeparator = "_ml-a";
export var highlight = "_ml-4";
export var resultIcon = "_ml-5";
export var resultItem = "_ml-7";
export var resultSubtitle = "_ml-3";
export var resultTitle = "_ml-2";
export var resultsList = "_ml-1";
export var searchGroup = "_ml-6";
export var selected = "_ml-8";